// eslint-disable-next-line no-var
export var PaginateHelper = (window.PaginateHelper = new Class({
   Implements: Options,
   options: {
      container: document.body,
      ajaxResponder: 'updateContent',
      ajaxValues: {},
      onUpdate: false,
      onRequest: false,
   },

   initialize: function (options) {
      this.curPage = {};
      this.pagekey = $('pagekey').get('value');
      this.setOptions(options);

      $(this.options.container)
         .getElements('div.paginatedDiv')
         .each(function (pDiv) {
            pDiv.store('curPage', 1);
            let paginateEl = pDiv.getElement('div.pagination');
            if (!paginateEl) {
               return;
            }

            let type = paginateEl.get('id').split('_', 1)[0];
            this.addPaginationEvents(paginateEl);
            this.curPage[type] = 1;
         }, this);

      // Needs to be called because initializing is updating too.
      if (this.options.onUpdate) {
         this.options.onUpdate();
      }
   },

   addPaginationEvents: function (paginateEl) {
      let nextPage = paginateEl.getElement('a.nextPage');
      let prevPage = paginateEl.getElement('a.prevPage');
      let type = paginateEl.get('id').split('_', 1)[0];

      if (nextPage) {
         nextPage.addEvent('click', ev => {
            ev.stop();
            if (nextPage.hasClass('disabled')) {
               return;
            }
            this.curPage[type]++;
            this.updateContent(paginateEl);
         });
      }

      if (prevPage) {
         prevPage.addEvent('click', ev => {
            ev.stop();
            if (prevPage.hasClass('disabled')) {
               return;
            }
            if (this.curPage[type] > 0) {
               this.curPage[type]--;
            }
            this.updateContent(paginateEl);
         });
      }
   },

   updateContent: function (paginateEl) {
      let type = paginateEl.get('id').split('_', 1)[0];
      let pageLinks = paginateEl.getElements('a');
      const limit = document.querySelector('#activityTimeLimit');

      pageLinks.addClass('disabled');

      if (this.options.onRequest) {
         this.options.onRequest();
      }

      Object.append(this.options.ajaxValues, {
         pagekey: this.pagekey,
         type: type,
         page: this.curPage[type],
         limit: limit ? limit.get('value') : null,
      });

      new Request.AjaxIO(this.options.ajaxResponder, {
         onSuccess: function (response) {
            let paginatedDiv = paginateEl.getParent('div.paginatedDiv');
            paginatedDiv.set('html', response.html);
            if (response.success === true) {
               let newPaginationDiv = paginatedDiv.getElement('div.pagination');
               this.addPaginationEvents(newPaginationDiv);
               this.curPage[type] = response.curPage;
               if (this.options.onUpdate) {
                  this.options.onUpdate();
               }
            }
         }.bind(this),
         onComplete: function (response) {
            pageLinks.removeClass('disabled');
         }.bind(this),
      }).send(this.options.ajaxValues);
   },
}));
